// extracted by mini-css-extract-plugin
export default {"table":"index_table_kis75","green":"index_green_ZeWT-","black":"index_black_FXSB3","grey":"index_grey_3g5WO"};